// extracted by mini-css-extract-plugin
export default {"container":"ParcelList_container__AS95l","listContainer":"ParcelList_listContainer__AFS4L"};